import { createContext } from "react";
import useAgentProjectSummaries from "../hooks/data/useAgentProjectSummaries";

export interface IAgentProjectSummaries extends ReturnType<typeof useAgentProjectSummaries> {

};

const AgentProjectSummariesContext = createContext<IAgentProjectSummaries>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default AgentProjectSummariesContext